import { render, staticRenderFns } from "./PlaceSignatures.vue?vue&type=template&id=f84d9fdc&scoped=true"
import script from "./PlaceSignatures.vue?vue&type=script&lang=js"
export * from "./PlaceSignatures.vue?vue&type=script&lang=js"
import style0 from "./PlaceSignatures.vue?vue&type=style&index=0&id=f84d9fdc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84d9fdc",
  null
  
)

export default component.exports